
// src/Views/HomePage.js
import React, { useState } from 'react';
import './Home.css';

const HomePage = () => {




    return (
        <div className="landing">
      <header className="nav">

   </header>

            <main className="hero">
                <h1 className="hero-title">
                    FINANCE • ANALYTICS • AUTOMATION
                </h1>

                <div className="hero-accent" aria-hidden="true"/>
                <p className="hero-subtitle">Turning Chaos into efficient Systems</p>


            </main>

            <section className="middle-section">
                <div className="actions">
                    <a className="btn btn-primary" href="#dashboard" aria-label="View Dashboard">
                        View Dashboard
                    </a>
                    <a className="btn btn-secondary" href="#contact" aria-label="Contact Me">
                        Contact
                    </a>
                </div>

                <div className="gallery-break" aria-label="Showcase placeholder">
                    <div className="build-progress-container">
                        <div className="build-header">
                            <span className="build-badge">In Development</span>
                            <h3 className="build-heading">Building a Full-Stack Analytics Platform</h3>
                        </div>

                        <div className="build-timeline-info">
                            <div className="timeline-item">
                                <div className="timeline-phase completed">
                                    <span className="phase-icon">✓</span>
                                    <div className="phase-content">
                                        <strong>Phase 1: Frontend</strong>
                                        <p>React application with responsive design</p>
                                    </div>
                                </div>
                            </div>

                            <div className="timeline-item">
                                <div className="timeline-phase in-progress">
                                    <span className="phase-icon">⚙️</span>
                                    <div className="phase-content">
                                        <strong>Phase 2: Backend Development</strong>
                                        <p>Building APIs, authentication, and database integration</p>
                                    </div>
                                </div>
                            </div>

                            <div className="timeline-item">
                                <div className="timeline-phase pending">
                                    <span className="phase-icon">📊</span>
                                    <div className="phase-content">
                                        <strong>Phase 3: Analytics Dashboard</strong>
                                        <p>Real-time data visualization and reporting features</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="build-tech-stack">
                            <p className="tech-label">Tech Stack:</p>
                            <div className="tech-badges">
                                <span className="tech-badge">React</span>
                                <span className="tech-badge">Python/FastAPI</span>
                                <span className="tech-badge">Firebase</span>
                                <span className="tech-badge">Analytics</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>




            <section className="mission">
        <h2 className="section-title">Mission</h2>
        <p className="section-text">
          Interested in work analytical work with passions for automation and data.
          In my free time I enjoy soccer and snowboarding. I build custom reports
          and deliver sharp, actionable analytics.To transform chaotic data into
          efficient systems that empower businesses to make confident, data-driven
          decisions. I'm always looking for new challenges and opportunities to apply
          my analytical skills in innovative ways.
        </p>
      </section>
    </div>
    );
};

export default HomePage;

